import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HistoryIcon from "@mui/icons-material/History";
import GroupIcon from "@mui/icons-material/Group";
import UserInvitation from "./UserInvitation";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const SettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user.user);
  const isAdmin = user?.role === 'ADMIN';

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <Typography variant="h4" gutterBottom align="center">
        Settings
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 3 }}>
        {/* Update Profile */}
        <Card sx={{ boxShadow: 3 }}>
          <CardContent sx={{ display: "flex", alignItems: "center" }}>
            <AccountCircleIcon sx={{ fontSize: 40, mr: 2 }} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" component="div">
                Update Profile
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Change your account details and profile information.
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={() => handleNavigation("/profile")}
              color="primary"
            >
              Update
            </Button>
          </CardContent>
        </Card>

        <Divider />

        {/* User Management (Admin Only) */}
        {isAdmin && (
          <Card sx={{ boxShadow: 3 }}>
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <GroupIcon sx={{ fontSize: 40, mr: 2 }} />
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h6" component="div">
                  User Management
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Invite and manage users in your enterprise account.
                </Typography>
              </Box>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  // We'll expand this section below instead of navigating
                  const element = document.getElementById('user-invitation-section');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Manage
              </Button>
            </CardContent>
          </Card>
        )}

        <Divider />

        {/* Billing History */}
        <Card sx={{ boxShadow: 3 }}>
          <CardContent sx={{ display: "flex", alignItems: "center" }}>
            <HistoryIcon sx={{ fontSize: 40, mr: 2 }} />
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" component="div">
                Usage History
              </Typography>
              <Typography variant="body2" color="textSecondary">
                View your usage history and reports.
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={() => handleNavigation("/view/billing-history")}
              color="primary"
            >
              View
            </Button>
          </CardContent>
        </Card>
      </Box>

      {/* User Invitation Section */}
      {isAdmin && (
        <Box id="user-invitation-section" sx={{ mt: 4 }}>
          <UserInvitation />
        </Box>
      )}
    </Container>
  );
};

export default SettingsPage;
